// Traducerile bannerului cookie și ale etichetelor din footer.
export const consentText = {
  ro: {
    title: "Folosim cookie-uri",
    body: "Utilizăm cookie-uri necesare și, cu acordul dvs., cookie-uri pentru analiză.",
    details: "Detalii",
    necessary: "Doar necesare",
    accept: "Accept",
  },
  ru: {
    title: "Мы используем cookie",
    body: "Мы используем необходимые cookie, а с вашего согласия — cookie для аналитики.",
    details: "Подробнее",
    necessary: "Только необходимые",
    accept: "Принять",
  },
  en: {
    title: "We use cookies",
    body: "We use necessary cookies and, with your consent, analytics cookies.",
    details: "Details",
    necessary: "Necessary only",
    accept: "Accept",
  },
};
